export const SAVE_SELECTED_INSTANCE = 'SAVE_SELECTED_INSTANCE';
export const CLEAR_SELECTED_INSTANCE = 'CLEAR_SELECTED_INSTANCE';
